import React, {
  useRef,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useState,
} from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import "../css/InputTextClausulas.css";

const InputTextClausulas = forwardRef((props, ref) => {
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useImperativeHandle(ref, () => containerRef.current);

  // 1. Inicialización de Quill
  useEffect(() => {
    if (quillInstance.current) return;

    /*const toolbarOptions = [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ align: [] }],
    ]; */

    const toolbarOptions = [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ align: [] }],
    ];

    const quill = new Quill(editorRef.current, {
      theme: "snow",
      readOnly: props.inactive,
      placeholder: props.placeholder,
      modules: { toolbar: toolbarOptions },
    });

    quillInstance.current = quill;

    if (props.input) {
      quill.clipboard.dangerouslyPasteHTML(props.input);
    }

    quill.on("text-change", () => {
      const html = quill.root.innerHTML;
      const text = quill.getText();
      const valueToSend =
        html === "<p><br></p>" || text.trim().length === 0 ? "" : html;

      if (props.onChange) props.onChange(valueToSend);
    });
  }, []);

  // 2. Sincronización
  useEffect(() => {
    if (
      quillInstance.current &&
      props.input !== quillInstance.current.root.innerHTML
    ) {
      quillInstance.current.clipboard.dangerouslyPasteHTML(props.input || "");
    }
  }, [props.input]);

  // 3. Estado Inactivo
  useEffect(() => {
    if (quillInstance.current) {
      quillInstance.current.enable(!props.inactive);
    }
  }, [props.inactive]);

  // Clase dinámica para el estado expandido
  const expansionClass = isExpanded ? "state-expanded" : "state-collapsed";

  return (
    <div
      ref={containerRef}
      id={props.id}
      tabIndex={props.tabIndex}
      // "quill-root" es nuestra clase base.
      // Las props.extra se añaden por si el padre manda clases custom.
      className={`quill-root ${expansionClass} ${props.extra || ""} ${
        props.inactive ? "settings-inactive" : ""
      } ${props.bkg ? "marked-bkg" : ""}`}
    >
      {/* Contenedor flexible para Quill */}
      <div className="quill-flex-container">
        <div ref={editorRef} />
      </div>

      {/* Botón Toggle */}
      <button
        type="button"
        className="btn-toggle-size"
        onClick={(e) => {
          e.preventDefault();
          setIsExpanded(!isExpanded);
        }}
        onMouseDown={(e) => e.preventDefault()}
      >
        {isExpanded ? "Ver menos" : "Ver más"}
      </button>
    </div>
  );
});

export default InputTextClausulas;
